module.exports = __webpack_public_path__ + "img/arrow-back.ad806ab5.svg";